import React, { Component } from 'react'
import { connect } from 'react-redux'
import CreateInquiry from 'containers/project-creation/create-view'
import { createProject } from "store/projectCreation/projectCreationActions";
import 'less/list.less'
import 'less/project.less'
import 'less/new-project.less'

function mapStateToProps (state) {
  return {
    initialValues: {  ...state.projectCreation, id :state.user.userId}
  }
}

class projectCreation extends Component {

  submitProjectCreation = (values) => { 
    this.props.createProject(values)
  }

  render () {
    return <CreateInquiry
          initialValues={this.props.initialValues}
          submitProjectCreation={this.submitProjectCreation }
          showSnackbarMessageError = {this.props.showSnackbarMessageError}
          hideSnackbarMessage = {this.props.hideSnackbarMessage}
          {...this.props}
        />
  }
}

const mapDispatch = {
    createProject,
    showSnackbarMessageError: message => ({
      type: 'SHOW_MESSAGE',
      payload: {
        message: message,
        className: 'copy-screeners-snackbar',
      },
    }),
    hideSnackbarMessage: () => ({type:'HIDE_MESSAGE'}),
}

export default connect(mapStateToProps, mapDispatch)(projectCreation)
